import React from "react";

import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import { pickValue } from "./utils";
import Auth from "routes/Auth";

const LeadTime = ({
  teamId,
  teams,
  competitionMetrics,
  metricsReports,
}) => {
  const teamsIds = teams.map(i => Number(i.id));
  const data = Auth.getPosition() === 'Student'
    ? metricsReports
      ? metricsReports.results.filter(i => teamsIds.includes(Number(i.team)))
      : []
    : competitionMetrics
      ? competitionMetrics.map(i => ({
          ...i,
          avg_lead_time: i['Avg Lead Time'] || 0,
        }))
      : [];
  const obj = data.find(i => Number(i.team) === teamId);
  const avgLeamTime = (obj ? obj.avg_lead_time : 0).toFixed(2);
  const chartData = pickValue(teams, data, 'avg_lead_time').map(i => ({
    ...i,
    value: Number((i.value || 0).toFixed(2)),
  }));

  return (
    <OnePanelChart
      title="Lead Time"
      chartTitle="LEAD TIME"
      vertical
      suffix=" hrs"
      data={chartData}
      teams={teams}
    >
      <Text>
        The average time it takes for your products to be delivered to customers is <b>{avgLeamTime}</b> hours.
      </Text>
    </OnePanelChart>
  );
};

export default LeadTime;



// WEBPACK FOOTER //
// ./src/components/analysis/LeadTime.js